import { SpecialistPage } from '@features/farmerOffer/specialistProfile/specialistProfilePage';

export const SpecialistProfile = () => {
	return <SpecialistPage />;
};
